import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, ChevronDown } from "lucide-react";

const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const substringFilter = (_value, search, keywords) => (norm(keywords?.[0]).includes(norm(search)) ? 1 : 0);

export const SearchableSelect = ({ value, onChange, options, placeholder, searchPlaceholder = "Rechercher...", className = "", testId }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={`flex w-full items-center justify-between gap-2 rounded-xl border border-gray-200 bg-white px-3 text-left ${className}`}
        >
          <span className={`truncate ${selected ? "text-[#1E2A5A]" : "text-[#6B7280]"}`}>{selected?.label || placeholder}</span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[200px] p-0 rounded-xl" align="start">
        <Command filter={substringFilter}>
          <CommandInput placeholder={searchPlaceholder} data-testid={testId && `${testId}-search`} />
          <CommandList className="max-h-[240px]">
            <CommandEmpty className="py-4 text-center text-xs text-[#6B7280]">Aucun résultat</CommandEmpty>
            {options.map((o) => (
              <CommandItem
                key={o.value}
                value={o.value}
                keywords={[o.label]}
                onSelect={() => { onChange(o.value); setOpen(false); }}
                className="text-sm"
              >
                <Check className={`mr-2 h-4 w-4 text-[#20C997] ${o.value === value ? "opacity-100" : "opacity-0"}`} />
                <span className="truncate">{o.label}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
